// extracted by mini-css-extract-plugin
export default {"title":"AirportHotelDetails_title__3FQHr","total":"AirportHotelDetails_total__8Mcc-","edit":"AirportHotelDetails_edit__m-D7W"};